/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc
 */

export const BrandFilterTypename = 'com.hubspot.sales.documents.models.directory.BrandFilter';
export const BrandFilterDiscriminant = 'BrandFilter';
export const BrandFilterDiscriminantKey = '_type';
export const CreatedByFilterTypename = 'com.hubspot.sales.documents.models.directory.CreatedByFilter';
export const CreatedByFilterDiscriminant = 'CreatedByFilter';
export const CreatedByFilterDiscriminantKey = '_type';
export const DirectoryEntryIFDiscriminantKey = '_type';
export const DirectoryFilterDiscriminantKey = '_type';
export const DocumentEntryTypename = 'com.hubspot.sales.documents.models.directory.DocumentEntry';
export const DocumentEntryDiscriminant = 'DocumentEntry';
export const DocumentEntryDiscriminantKey = '_type';
export const FolderEntryTypename = 'com.hubspot.sales.documents.models.directory.FolderEntry';
export const FolderEntryDiscriminant = 'FolderEntry';
export const FolderEntryDiscriminantKey = '_type';
export const FolderFilterTypename = 'com.hubspot.sales.documents.models.directory.FolderFilter';
export const FolderFilterDiscriminant = 'FolderFilter';
export const FolderFilterDiscriminantKey = '_type';
export const TeamFilterTypename = 'com.hubspot.sales.documents.models.directory.TeamFilter';
export const TeamFilterDiscriminant = 'TeamFilter';
export const TeamFilterDiscriminantKey = '_type';
export const listEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc',
  rpcName: 'listEntries',
  auth: 'external',
  fingerprint: 'JUgIA08gn9olUYn-IOAsnm-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const countEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc',
  rpcName: 'countEntries',
  auth: 'external',
  fingerprint: '0t2uiNKXGVlDdktfOPVl4G-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchEntriesRpc = {
  serviceName: 'com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc',
  rpcName: 'searchEntries',
  auth: 'external',
  fingerprint: 'MGl-dza-DzAbWz77TvE_e2-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const countSearchResultsRpc = {
  serviceName: 'com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc',
  rpcName: 'countSearchResults',
  auth: 'external',
  fingerprint: '94bHuiP2UY1DdktfOPVl4G-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEntryRpc = {
  serviceName: 'com.hubspot.sales.documents.portal.rpc.SalesDocumentIndexPortalRpc',
  rpcName: 'getEntry',
  auth: 'external',
  fingerprint: 'DipAxp13vRYLg_lZt2lfKG-JGNNLQ5pl',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};